import {
  Box,
  Checkbox,
  CssBaseline,
  ListItem,
  Backdrop,
  CircularProgress,
  ListItemText,
  Popover,
  TextField,
  Typography,
} from '@mui/material';
import { listAccountTransactionDetailsv3, listaccounttransactiondetailstotals } from '../../../../graphql';
import { API, graphqlOperation } from 'aws-amplify';
import { useSelector } from 'react-redux';
import { showWarningSnackbar } from '../../../../components/snackBar/snakbar';
import { useEffect, useState } from 'react';
import { useThemes } from '../../../../components/Theme/theme';

const DropDown = ({
  openPopover,
  anchorEl,
  handleClose,
  list,
  loading,
  includeOpeningBalance,
  setTableData,
  backdropOpen,
  setBackdropOpen,
  setAnchorEl,
  selectedTab,
  selectedAccount = [],
  setSelectedAccount,
}) => {
  const dashboardData = useSelector((state) => state?.DashboardDataReducer);

  const { startTimeStamp, endTimeStamp } = dashboardData?.report;
  const [accList, setAccList] = useState();
  const [searchCashBookText, setSearchCashBookText] = useState('');
  useEffect(() => {
    setAccList(list);
  }, [selectedTab, list]);
  const singleSelect = async (account, from, to) => {
    console.log(selectedTab, 'account');
    const accountsIds = selectedAccount.map((account) => account.accountsid);
    setBackdropOpen(true);
    localStorage.removeItem('selectedAccount');

    // if ((!accountsIds.includes(account.accountsid) && selectedTab !== 7) || selectedTab === 7) {
    setSelectedAccount([]);
    setTableData([]);
    setSelectedAccount((prev) => [{ accountsid: account.accountsid, accountname: account.accountname, selectedTab }]);
    try {
      let response = await API.graphql(
        graphqlOperation(listAccountTransactionDetailsv3, {
          accountid: account.accountsid,
          startdate: startTimeStamp,
          openingbalance: includeOpeningBalance === true ? 1 : 0,
          enddate: endTimeStamp,
          columnname: 'enteredtimestamp',
          searcharray: '[]',
          searchmode: 0,
          ordertype: 'asc',
          rowfrom: from,
          limitno: to,
        })
      );
      const resCount = await API.graphql(
        graphqlOperation(listaccounttransactiondetailstotals, {
          accountid: account.accountsid,
          openingbalance: includeOpeningBalance === true ? 1 : 0,
          startdate: startTimeStamp,
          enddate: endTimeStamp,
        })
      );
      if (selectedTab !== 5) {
        setTableData((prevItems) => [
          // ...prevItems,
          {
            data: response.data.listAccountTransactionDetailsv3,
            accountid: account.accountsid,
            count: resCount.data.listaccounttransactiondetailstotals[0]?.transactioncount,
            credit: resCount.data.listaccounttransactiondetailstotals[0]?.totalcredit,
            debit: resCount.data.listaccounttransactiondetailstotals[0]?.totaldebit,
            total: resCount.data.listaccounttransactiondetailstotals[0]?.closingbalance,
          },
        ]);
      } else if (accountsIds.includes(account.accountsid) && selectedTab !== 5) {
        showWarningSnackbar('You have already selected this account');
      }
    } catch (err) {
      console.log(err, 'err');
    }
    // }
    setBackdropOpen(false);
    setAnchorEl(null);
  };

  const selectAccount = async (account, from, to) => {
    localStorage.removeItem('selectedAccount');
    setBackdropOpen(true);
    const existingItemIndex = selectedAccount?.findIndex((item) => item.accountsid === account.accountsid);
    if (selectedAccount.length <= 4) {
      setSelectedAccount((prevState) => {
        if (existingItemIndex !== -1) {
          return selectedAccount?.filter((item) => item.accountsid !== account.accountsid);
        } else {
          const newItem = { accountsid: account.accountsid, accountname: account.accountname, selectedTab }; // Example object to add
          return [newItem, ...selectedAccount];
        }
      });

      if (existingItemIndex === -1 && selectedTab !== 5) {
        let response = await API.graphql(
          graphqlOperation(listAccountTransactionDetailsv3, {
            accountid: account.accountsid,
            columnname: 'enteredtimestamp',
            searcharray: '[]',
            searchmode: 0,
            openingbalance: includeOpeningBalance === true ? 1 : 0,
            ordertype: 'asc',
            startdate: startTimeStamp,
            enddate: endTimeStamp,
            rowfrom: from,
            limitno: to,
          })
        );
        const resCount = await API.graphql(
          graphqlOperation(listaccounttransactiondetailstotals, {
            accountid: account.accountsid,
            startdate: startTimeStamp,
            openingbalance: includeOpeningBalance === true ? 1 : 0,
            enddate: endTimeStamp,
          })
        );
        setTableData((prevItems) => {
          const newItem = {
            data: response.data.listAccountTransactionDetailsv3,
            accountid: account.accountsid,
            count: resCount.data.listaccounttransactiondetailstotals[0]?.transactioncount || '',
            credit: resCount.data.listaccounttransactiondetailstotals[0]?.totalcredit || '',
            debit: resCount.data.listaccounttransactiondetailstotals[0]?.totaldebit || '',
            total: resCount.data.listaccounttransactiondetailstotals[0]?.closingbalance || '',
          };
          return [newItem, ...prevItems];
        });
      } else if (existingItemIndex !== -1 && selectedTab !== 5) {
        setTableData((prevData) => {
          const data = prevData.filter((acc) => acc.accountid !== account.accountsid);
          return data;
        });
      }
    } else {
      if (existingItemIndex !== -1 && selectedTab !== 5) {
        setSelectedAccount((prevState) => {
          if (existingItemIndex !== -1) {
            // If the item is found, remove it from the state

            return selectedAccount?.filter((item) => item.accountsid !== account.accountsid);
          } else {
            return [...selectedAccount];
          }
        });
        setTableData((prevData) => prevData.filter((innerArray) => innerArray[0]?.accountid !== account.accountsid));
      } else if (selectedAccount.length > 4 && selectedTab !== 5) {
        showWarningSnackbar('Cannot select more than 4 accounts');
      }
    }
    setBackdropOpen(false);
  };
  const periodChange = async (account, from, to) => {
    setTableData([]);
    try {
      setBackdropOpen(true);
      let response = await API.graphql(
        graphqlOperation(listAccountTransactionDetailsv3, {
          accountid: account.accountsid,
          columnname: 'enteredtimestamp',
          searcharray: '[]',
          searchmode: 0,
          ordertype: 'asc',
          openingbalance: includeOpeningBalance === true ? 1 : 0,
          startdate: startTimeStamp,
          enddate: endTimeStamp,
          rowfrom: from,
          limitno: to,
        })
      );
      const resCount = await API.graphql(
        graphqlOperation(listaccounttransactiondetailstotals, {
          accountid: account.accountsid,
          startdate: startTimeStamp,
          openingbalance: includeOpeningBalance === true ? 1 : 0,
          enddate: endTimeStamp,
        })
      );
      if (selectedTab !== 5) {
        setTableData((prevItems) => {
          const existingIndex = prevItems.findIndex((item) => item.accountid === account.accountsid);

          const newItem = {
            data: response.data.listAccountTransactionDetailsv3,
            accountid: account.accountsid,
            count: resCount.data.listaccounttransactiondetailstotals[0]?.transactioncount,
            credit: resCount.data.listaccounttransactiondetailstotals[0]?.totalcredit,
            debit: resCount.data.listaccounttransactiondetailstotals[0]?.totaldebit,
            total: resCount.data.listaccounttransactiondetailstotals[0]?.closingbalance,
          };

          if (existingIndex !== -1) {
            // Replace existing record
            const updated = [...prevItems];
            updated[existingIndex] = newItem;
            return updated;
          }

          // Add new record if not exists
          return [...prevItems, newItem];
        });
      }
      // else if (selectedTab !== 5) {
      //   setTableData((prevItems) => [
      //     ...prevItems,
      //     {
      //       data: [
      //         {
      //           accountid: account.accountsid,
      //           vouchertype: 'No',
      //           accountname: account.accountname,
      //         },
      //       ],
      //     },
      //   ]);
      // }
    } catch (err) {
      console.log(err);
    } finally {
      setBackdropOpen(false);
    }
  };

  useEffect(() => {
    selectedAccount?.length > 0 && selectedTab !== 5 && selectedAccount?.map((acc) => periodChange(acc, 0, 25));
  }, [startTimeStamp, endTimeStamp]);

  useEffect(() => {
    const filteredData = list.filter((item) => item.accountname.toLowerCase().includes(searchCashBookText.toLowerCase()));
    setAccList(filteredData);
  }, [searchCashBookText]);
  const restrictedIds = [12, 23, 24];
  const { theme } = useThemes();
  return (
    <Popover
      id="tree-popover"
      open={openPopover}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
      sx={{
        marginTop: '10px',
        '& .MuiPaper-root': {
          maxHeight: '70vh',
          overflow: 'auto',
        },
      }}
    >
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          background: '#fff',
          minWidth: '350px',
          backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? '#26282A' : 'white',
        }}
      >
        {list && list.length > 10 && (
          <TextField
            variant="outlined"
            required={true}
            size="small"
            InputLabelProps={{ shrink: true }}
            id="cashBook"
            sx={{
              textAlign: 'center',
              justifyContent: 'center',
              width: '95%',
              fontSize: 14,
              height: 40,
              m: 1,
              backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? '#0b0705' : '#faf5ef',
              borderRadius: '10px',
              color: '#26282A',
              '.MuiOutlinedInput-notchedOutline': {
                border: 'none',
                outline: 'none',
              },
              '.MuiInputBase-input ': {
                fontWeight: 'bold',
              },
              '.MuiSvgIcon-fontSizeMedium ': {
                color: 'primary.main',
                fontSize: '30px',
              },
            }}
            placeholder="Search"
            value={searchCashBookText}
            onChange={(e) => setSearchCashBookText(e.target.value)}
          />
        )}
        <Box>
          {loading === true ? (
            <ListItem
              sx={{
                cursor: 'pointer',
                '&.MuiListItem-root': {
                  paddingTop: '0px',
                  paddingBottom: '0px',
                  overflow: 'hidden',
                },
              }}
            >
              <ListItemText primary={`Loading...`} />
            </ListItem>
          ) : (
            <Box
              sx={{
                fontWeight: 'bold',
                fontSize: '16px',
              }}
            >
              <ListItem
                sx={{
                  cursor: 'pointer',
                  '&.MuiListItem-root': {
                    paddingTop: '0px',
                    paddingBottom: '0px',
                    overflow: 'hidden',
                    borderBottom: '1px solid #ccc',
                  },
                }}
                secondaryAction={
                  selectedTab !== 7 && (
                    <Typography
                      variant="p"
                      sx={{
                        color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                      }}
                    >
                      Multi select
                    </Typography>
                  )
                }
              >
                {selectedTab !== 7 && (
                  <Typography
                    variant="p"
                    sx={{
                      color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                    }}
                  >
                    Accounts
                  </Typography>
                )}
              </ListItem>
              <CssBaseline />
              <Box>
                {selectedTab !== 1
                  ? accList &&
                    accList.length > 0 &&
                    accList
                      .filter((fil) => !restrictedIds.includes(fil.accountsid))
                      .sort((a, b) => a.accountname.localeCompare(b.accountname))
                      .map((data) => {
                        return (
                          <ListItem
                            key={data.accountsid}
                            sx={{
                              cursor: 'pointer',
                              '&.MuiListItem-root': {
                                paddingTop: '0px',
                                paddingBottom: '0px',
                                alignItems: 'center',
                                overflow: 'hidden',
                                '&:hover': {
                                  backgroundColor: '#E6CED7',
                                },
                              },
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedAccount([data]);
                              singleSelect(data, 0, 25);
                            }}
                            secondaryAction={
                              selectedTab !== 7 && (
                                <Checkbox
                                  sx={{
                                    marginRight: '2px',
                                  }}
                                  edge="end"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const isAlreadySelected = selectedAccount.some((acc) => acc.accountsid === data.accountsid);

                                    if (isAlreadySelected) {
                                      // Remove the account
                                      const updatedAccounts = selectedAccount.filter((acc) => acc.accountsid !== data.accountsid);
                                      setSelectedAccount(updatedAccounts);
                                      selectAccount(data, 0, 25);
                                    } else {
                                      // Add the account if under limit
                                      if (selectedAccount.length < 4) {
                                        setSelectedAccount([...selectedAccount, data]);
                                        selectAccount(data, 0, 25);
                                      } else {
                                        showWarningSnackbar('Cannot select more than 4 accounts');
                                      }
                                    }
                                  }}
                                  checked={selectedAccount?.find((acc) => acc.accountsid === data.accountsid)?.accountsid ? true : false}
                                />
                              )
                            }
                          >
                            <ListItemText
                              sx={{
                                whiteSpace: 'wrap', // Optional: Hide overflow text
                                textOverflow: 'ellipsis', // Optional: Show ellipsis for overflow text
                              }}
                              id={data.accountsid}
                              primary={`${data.accountname}`}
                            />
                          </ListItem>
                        );
                      })
                  : (() => {
                      const filteredList =
                        accList && accList.length > 0
                          ? accList
                              .filter((fil) => !restrictedIds.includes(fil.accountsid))
                              .sort((a, b) => a.accountname.localeCompare(b.accountname))
                          : [];

                      const cashItems = filteredList.filter((item) => item.accountgroupname === 'Cash in Hand');
                      const bankItems = filteredList.filter((item) => item.accountgroupname === 'Bank Accounts');

                      const renderAccountItem = (data) => {
                        return (
                          <ListItem
                            key={data.accountsid}
                            sx={{
                              cursor: 'pointer',
                              '&.MuiListItem-root': {
                                paddingTop: '0px',
                                paddingBottom: '0px',
                                alignItems: 'center',
                                overflow: 'hidden',
                                '&:hover': {
                                  backgroundColor: '#E6CED7',
                                },
                              },
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedAccount([data]);
                              singleSelect(data, 0, 25);
                            }}
                            secondaryAction={
                              selectedTab !== 7 && (
                                <Checkbox
                                  sx={{
                                    marginRight: '2px',
                                  }}
                                  edge="end"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const isAlreadySelected = selectedAccount.some((acc) => acc.accountsid === data.accountsid);

                                    if (isAlreadySelected) {
                                      // Remove the account
                                      const updatedAccounts = selectedAccount.filter((acc) => acc.accountsid !== data.accountsid);
                                      setSelectedAccount(updatedAccounts);
                                      selectAccount(data, 0, 25);
                                    } else {
                                      // Add the account if under limit
                                      if (selectedAccount.length < 4) {
                                        setSelectedAccount([...selectedAccount, data]);
                                        selectAccount(data, 0, 25);
                                      } else {
                                        showWarningSnackbar('Cannot select more than 4 accounts');
                                      }
                                    }
                                  }}
                                  checked={selectedAccount?.find((acc) => acc.accountsid === data.accountsid)?.accountsid ? true : false}
                                />
                              )
                            }
                          >
                            <ListItemText
                              sx={{
                                whiteSpace: 'wrap', // Optional: Hide overflow text
                                textOverflow: 'ellipsis', // Optional: Show ellipsis for overflow text
                              }}
                              id={data.accountsid}
                              primary={`${data.accountname}`}
                            />
                          </ListItem>
                        );
                      };

                      return (
                        <>
                          {bankItems.length > 0 && (
                            <Box
                              sx={{
                                border: '1px solid #4CAF50',
                                borderRadius: '4px',
                                margin: '8px',
                                padding: '4px',
                              }}
                            >
                              <Typography
                                variant="p"
                                sx={{
                                  fontWeight: 'bold',
                                  fontSize: '16px',
                                  padding: '8px 16px',
                                  color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                                  // borderBottom: '1px solid #4CAF50',
                                }}
                              >
                                Bank A/c
                              </Typography>
                              {bankItems.map((data) => renderAccountItem(data))}
                            </Box>
                          )}
                          {cashItems.length > 0 && (
                            <Box
                              sx={{
                                border: '1px solid #2196F3',
                                borderRadius: '4px',
                                margin: '8px',
                                padding: '4px',
                              }}
                            >
                              <Typography
                                variant="p"
                                sx={{
                                  fontWeight: 'bold',
                                  fontSize: '16px',
                                  padding: '8px 16px',
                                  color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                                  // borderBottom: '1px solid #2196F3',
                                }}
                              >
                                Cash A/c
                              </Typography>
                              {cashItems.map((data) => renderAccountItem(data))}
                            </Box>
                          )}
                        </>
                      );
                    })()}
              </Box>
            </Box>
          )}
        </Box>
      </Box>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Popover>
  );
};

export default DropDown;
